export enum DirectConnectionType {
    Binary = 0,
    AnalogVideo = 1,
    Analog = 4,
    HighLevelSound = 6,
    LowLevelSound = 7,
    GPIOP = 9,
    MemoryCardSlot = 10,
    SimCardSlot = 11,
    DirectUsbConnector = 12,
    SataConnector = 13,
    DisplayConnector = 14,
    LVDSConnector = 15,
    WirelessP2PLink = 16,
    Mx2WireLink = 17,
    AntennaConnector = 18,
}
